export default __webpack_public_path__ + "static/media/coalesceether.7eb0aa13.png";